import React, { useEffect, useState } from "react";
import { Calendar as BigCalendar, momentLocalizer } from "react-big-calendar";
import { useDispatch, useSelector } from "react-redux";
import getEvents from "actions/event";
import isArray from "lodash/isArray";
import moment from "moment";

import CalendarHeader from "./CalendarHeader";
import EventDetails from "./EventDetails";

import "react-big-calendar/lib/css/react-big-calendar.css";
import styles from "./Calendar.css";

const localizer = momentLocalizer(moment);

export function Calendar() {
  const dispatch = useDispatch();
  const { calendarToken, events } = useSelector((state) => ({
    calendarToken: state.currentUser.calendarToken,
    events: state.events,
  }));

  const [selectedFilters, setSelectedFilters] = useState([
    "call",
    "viewing",
    "due_proposal",
    "lease_expiration",
    "lease_start",
    "space_available",
  ]);

  function handleRangeChange(range) {
    const start = isArray(range) ? range[0] : range.start;
    const end = isArray(range) ? range[range.length - 1] : range.end;

    dispatch(getEvents(moment(start).format(), moment(end).format()));
  }

  useEffect(() => {
    const start = moment().format();
    const end = moment().add(1, "month").format();

    dispatch(getEvents(start, end));
  }, [dispatch]);

  const components = {
    event: EventDetails,
    toolbar: (props) => (
      <CalendarHeader
        {...props}
        calendarToken={calendarToken}
        onFilter={setSelectedFilters}
        selectedFilters={selectedFilters}
      />
    ),
  };

  return (
    <div className={styles.root}>
      <BigCalendar
        components={components}
        defaultDate={new Date()}
        defaultView="month"
        endAccessor={({ end }) => moment(end).toDate()}
        events={events.filter((e) => selectedFilters.includes(e.type))}
        formats={{ eventTimeRangeFormat: () => null }}
        localizer={localizer}
        onRangeChange={handleRangeChange}
        startAccessor={({ start }) => moment(start).toDate()}
        style={{ height: "100%" }}
      />
    </div>
  );
}

export default Calendar;
